module.exports = __webpack_public_path__ + "static/media/no_image.b54086e5.jpg";